import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class CreateDocumentMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.createDocument.click_button_save_draft, (data) => {
      mixpanel.track(event.createDocument.click_button_save_draft, { ...data });
    });
    AnalyticsEventBus.$on(event.createDocument.click_button_save_draft_and_create_new, (data) => {
      mixpanel.track(event.createDocument.click_button_save_draft_and_create_new, { ...data });
    });
    AnalyticsEventBus.$on(event.createDocument.click_button_approve, (data) => {
      mixpanel.track(event.createDocument.click_button_approve, { ...data });
    });
    AnalyticsEventBus.$on(event.createDocument.click_button_approve_and_print, (data) => {
      mixpanel.track(event.createDocument.click_button_approve_and_print, { ...data });
    });
    AnalyticsEventBus.$on(event.createDocument.click_button_approve_and_create_new, (data) => {
      mixpanel.track(event.createDocument.click_button_approve_and_create_new, { ...data });
    });
    AnalyticsEventBus.$on(event.createDocument.click_button_send_for_approve, (data) => {
      mixpanel.track(event.createDocument.click_button_send_for_approve, { ...data });
    });
  }
}
